export default __webpack_public_path__ + "static/media/leaf3.87294caf.svg";